import { ItemCategory } from '@models/item/itemCategory';
import { useStepFlow } from '@stackflow/react';
import { useContext } from 'react';

import ShopItemContext from '../../../../context/ShopItemContext';

function useSelectCategory(
    itemCategory: ItemCategory,
    categories: ItemCategory[],
) {
    const { shopId, categoryId } = useContext(ShopItemContext);
    const { replaceStep } = useStepFlow('ItemsActivity');
    const currentCategoryId = categoryId || categories[0]?.id;
    const { id } = itemCategory;
    const isSelected = currentCategoryId === id;

    const handleSelectCategory = () => {
        replaceStep({
            shopId, categoryId: id, type: 'ALL',
        });
    };

    return { isSelected, handleSelectCategory };
}

export default useSelectCategory;
